export default "__VITE_ASSET__vu$jUuyZ__"